import type { ReactNode } from "react";
import { AuthProvider } from "../context/AuthContext";
import { OrgProvider } from "../context/OrgContext";
import { SubscriptionProvider } from "../context/SubscriptionContext";
import { VerticalProvider } from "../context/VerticalContext";

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <AuthProvider>
      <OrgProvider>
        <VerticalProvider>
          <SubscriptionProvider>{children}</SubscriptionProvider>
        </VerticalProvider>
      </OrgProvider>
    </AuthProvider>
  );
}
